

import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Box, FormControl, FormControlLabel, FormGroup, Grid, Switch, Typography, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Components/Snackbar/SnackbarActions';
import DataService from '../../../../Service';
import EditIcon from '@material-ui/icons/Edit';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloseIcon from '@material-ui/icons/Close';
import { GLOBAL_STEPPER_DATA } from '../../../../Redux/actions';

const useStyles = makeStyles({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    drawerRoot: {
        top: 65,
        height: "calc(100% - 65px)",
        width: 400
    }
});

export default function PanelDrawer(props) {
    const classes = useStyles();
    const [pageData, setPageData] = React.useState([]);
    const [programAccessFlag, setProgramAccessFlag] = React.useState(false);
    const [programAccessName, setProgramAccessName] = React.useState('');
    const [partnerRoleOrganisationMapId, setPartnerRoleOrganisationMapId] = React.useState('');
    const dispatch = useDispatch();
    const global_data = useSelector((state) => state.stepperReducer);

    const handleChange = (e, obj) => {
        console.log(`object`, obj)
        const formData = new FormData();
        if (!programAccessFlag) {

            formData.append("organisation_id", props.orgId);
            formData.append("partner_profile_id", global_data.partner_profile);
            formData.append("partner_role_id", obj.id);
        } else {
            formData.append("partner_role_organisation_map_id", partnerRoleOrganisationMapId);
            formData.append("programme_id", obj.id);
        }
        formData.append("toggle", e.target.checked);


        DataService.createData(formData, programAccessFlag ? "partner_role_programme_maps" : "partner_role_organisation_maps").then((response) => {
            if(response.data){
            
            dispatch({ type: GLOBAL_STEPPER_DATA, payload: { partner_panel_access_id: response.data.id } });
            dispatch(showSnackbar("Success", ["Access updated successfully"]))

            }
            !programAccessFlag ? getListRoles() : getListProgram(partnerRoleOrganisationMapId)

        })
    }

    const openProgramData = (option) => {
        setPartnerRoleOrganisationMapId(option.partner_role_organisation_map_id)
        setProgramAccessName(option.value)
        setProgramAccessFlag(true)
        getListProgram(option.partner_role_organisation_map_id)

    }


    useEffect(() => { getListRoles() }, []);

    const getListProgram = (value) => {
        DataService.getDirectData(`/partner_role_organisation_maps/list_programe`, { organisation_id: props.orgId, partner_role_organisation_map_id: value }).then((res) => {
            res?.programme && setPageData(res?.programme)
            if(res?.message){
                setProgramAccessFlag(false)
                dispatch(showSnackbar("Error", [res.message]))
            }
        })
    }
    const getListRoles = (params) => {
        DataService.getDirectData(`/partner_role_organisation_maps/list_roles`, { partner_profile_id: global_data.partner_profile, organisation_id: props.orgId }).then((res) => {
            setPageData(res.list_roles.map((option) => { return { ...option, value: option.role, id: option.partner_role_id, active: option.active } }))
        })
    }


    const list = (anchor) => (
        <Box m={3}>
            <Box style={{ position: "absolute", right: 30 }} ><CloseIcon onClick={() => { props.setDrawerFlag(false) }} style={{ fontSize: 18, cursor: "pointer" }} /></Box>
            <Typography variant="h3" color="primary"><Box fontWeight="fontWeightBold">Organization {props.orgName}</Box></Typography>
            {
                programAccessFlag &&
                <Typography variant="h3">
                    <Box mt={2} fontWeight="fontWeightBold">
                        <ArrowBackIosIcon onClick={() => { getListRoles(); setProgramAccessFlag(false) }} style={{ fontSize: 16 }} />
                        Program Access for  <Typography component="span" style={{ fontSize: 18, fontWeight: "600" }} color="primary">{programAccessName}</Typography>
                    </Box>
                </Typography>
            }
            <Box>
                <FormControl component="fieldset" style={{ display: "block" }}>
                    <FormGroup>
                        <Box my={2} style={{ height: 15 }}>
                            <Grid container className={classes.root}>
                                <Grid item xs={!programAccessFlag ? 6 : 9}>
                                    <Typography variant="h3" ><Box fontWeight="fontWeightBold">{programAccessFlag ? "Program" : "Partner"} Access</Box></Typography>
                                </Grid>
                                <Grid item xs={!programAccessFlag ? 6 : 3}>
                                    <Typography variant="h3"><Box fontWeight="fontWeightBold">Yes/No</Box></Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        {
                            pageData.length>0 && pageData.map((option) => {
                                { console.log(`option`, option) }
                                return <Box my={1}>
                                    <Grid container className={classes.root} spacing={2}>
                                        <Grid item xs={!programAccessFlag ? 6 : 9}>
                                            <label>{option.value}</label>
                                        </Grid>
                                        <Grid item xs={!programAccessFlag ? 3 : 3}>
                                            <FormControlLabel
                                                style={{ alignSelf: "flex-end" }}
                                                control={<Switch checked={option.active} color={option.active ? "primary" : "default"} onChange={(e) => handleChange(e, option)} name={option.value} />}

                                            />
                                        </Grid>
                                        {
                                            !programAccessFlag && option.active &&
                                            <Grid item xs={3}>
                                                <Button disableElevation variant="outlined" style={{ textTransform: 'none' }} startIcon={<EditIcon />} onClick={() => { openProgramData(option); }}>
                                                    Edit
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>

                                </Box>
                            })
                        }

                    </FormGroup>
                </FormControl>
            </Box>
        </Box>
    );

    // props.parentCall(null)
    return (
        <div>
            <React.Fragment>
                <SwipeableDrawer
                    classes={{
                        paper: classes.drawerRoot,

                    }}
                    anchor={'right'}
                    open={props.drawerFlag}
                    onClose={props.parentToggleDrawer(false)}
                    onOpen={props.parentToggleDrawer(true)}
                >
                    {list('right')}
                </SwipeableDrawer>
            </React.Fragment>
        </div>
    );
}